import React, { useCallback, useEffect, useRef, useState } from 'react';
import defer from 'lodash/defer';

const findButtons = (menuElement) =>
  menuElement.current &&
  Array.from(menuElement.current.querySelectorAll('button'));

export const AccessibleMenuWithArrows = ({ ulClassName, children }) => {
  const menuElement = useRef(null);
  const [focusedIndex, setFocusIndex] = useState(0);

  useEffect(() => {
    // wait for portal elements to position
    defer(() => {
      menuElement.current && findButtons(menuElement)[focusedIndex]?.focus();
    });
  }, [focusedIndex]);

  const arrowsListener = useCallback(
    (event) => {
      const buttons = findButtons(menuElement);

      // down
      if (event.keyCode === 40) {
        setFocusIndex((index) => (index >= buttons.length - 1 ? 0 : index + 1));
        event.preventDefault();
      }
      // up
      if (event.keyCode === 38) {
        setFocusIndex((index) => (index <= 0 ? buttons.length - 1 : index - 1));
        event.preventDefault();
      }
    },
    [menuElement.current],
  );

  useEffect(() => {
    document.addEventListener('keydown', arrowsListener);
    return () => document.removeEventListener('keydown', arrowsListener);
  }, [arrowsListener]);

  return (
    <div role="list" className={ulClassName} ref={menuElement}>
      {children}
    </div>
  );
};
